import React, { useEffect, useState, useRef, memo } from 'react';
import { Eraser, PenTool } from 'lucide-react';
export function SketchPad() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [color, setColor] = useState('#f97316'); // Default orange
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    // Set actual size in memory (scaled to account for extra pixel density)
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * 2;
    canvas.height = rect.height * 2;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Normalize coordinate system to use css pixels
    ctx.scale(2, 2);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = 3;
    // Fill initial dark background
    ctx.fillStyle = '#121216';
    ctx.fillRect(0, 0, rect.width, rect.height);
  }, []);
  const startDrawing = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    let clientX, clientY;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };
  const draw = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    let clientX, clientY;
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    ctx.lineTo(x, y);
    ctx.strokeStyle = color;
    ctx.stroke();
  };
  const stopDrawing = () => {
    setIsDrawing(false);
  };
  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    ctx.fillStyle = '#121216';
    ctx.fillRect(0, 0, rect.width, rect.height);
  };
  return <div className="w-full mt-8 border border-app-border rounded-xl overflow-hidden bg-app-card" data-id="element-53">
      <div className="flex items-center justify-between p-3 border-b border-app-border bg-app-bg/50" data-id="element-54">
        <div className="flex items-center gap-2" data-id="element-55">
          <PenTool size={16} className="text-app-accent" data-id="element-56" />
          <span className="text-xs font-syne font-bold tracking-wider text-gray-400" data-id="element-57">
            QUICK SKETCH
          </span>
        </div>
        <div className="flex items-center gap-3" data-id="element-58">
          <div className="flex gap-2" data-id="element-59">
            {['#f97316', '#ffffff', '#a8a29e'].map(c => <button key={c} onClick={() => setColor(c)} className={`w-5 h-5 rounded-full border-2 transition-all ${color === c ? 'border-white scale-110' : 'border-transparent'}`} style={{
            backgroundColor: c
          }} data-id="element-60" />)}
          </div>
          <div className="w-px h-4 bg-app-border mx-1" data-id="element-61" />
          <button onClick={clearCanvas} className="text-gray-500 hover:text-white transition-colors" data-id="element-62">
            <Eraser size={16} data-id="element-63" />
          </button>
        </div>
      </div>
      <canvas ref={canvasRef} onMouseDown={startDrawing} onMouseMove={draw} onMouseUp={stopDrawing} onMouseOut={stopDrawing} onTouchStart={startDrawing} onTouchMove={draw} onTouchEnd={stopDrawing} className="w-full h-48 sm:h-64 cursor-crosshair touch-none" data-id="element-64" />
    </div>;
}